import { render, staticRenderFns } from "./AddData.vue?vue&type=template&id=54eb6cf5&scoped=true&"
import script from "./AddData.vue?vue&type=script&lang=js&"
export * from "./AddData.vue?vue&type=script&lang=js&"
import style0 from "./AddData.vue?vue&type=style&index=0&id=54eb6cf5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54eb6cf5",
  null
  
)

export default component.exports